export enum EventType {
	AnonymousStudentServiceReady = 'anonymous-student-service-ready',
	AnonymousStudentProfileUpdated = 'anonymous-student-profile-updated',
	AnonymousStudentProfileSynced = 'anonymous-student-profile-synced',
	AnonymousStudentStateChanged = 'anonymous-student-state-changed'
}
